module.exports = __webpack_public_path__ + "img/stock5.5015f626.png";